<div class="card mt-4">
  <div class="card-header">
    <div class="row" style="width: 100%">
      <div class="col-6">
        <h4 class="card-title">{{ settings.title || 'Analytics Bar Chart' }}</h4>
      </div>
      <div *ngIf="options && options.length > 0" class="col-6">
        <div ngbDropdown class="inline-block float-end">
          <button class="btn btn-outline-primary" id="dropdown" ngbDropdownToggle>
            {{ selected < 0 ? 'Please select...' : options[selected] }}
          </button>
          <div ngbDropdownMenu aria-labelledby="dropdown">
            <button ngbDropdownItem *ngFor="let s of options; let i = index" (click)="selectOption(i)">{{ options[i] }}</button>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="card-body">
    <div *ngIf="settings.subtitle">{{ settings.subtitle }}</div>
    <div>{{ formatDuration() }}</div>
    <app-analytics-graph
      *ngIf="selected >= 0"
      [metric]="settings.metric"
      [type]="settings.horizontal ? 'horizontalBar' : 'bar'"
      [defaultGrouping]="settings.grouping"
      [defaultDatasets]="settings.datasets || []"
      [customGrouping]="false"
      [from]="settings.from"
      [to]="settings.to"
      [filter]="filter"
      [exclude]="settings.exclude"
      [relative]="settings.relative"
      [labelNames]="settings.labelNames"
      [reload]="reloadGraph"
    >
    </app-analytics-graph>
  </div>
</div>
